import { render } from "./app-bk-2024-3-27.vue?vue&type=template&id=6484f094&ts=true"
import script from "./app-bk-2024-3-27.vue?vue&type=script&lang=ts"
export * from "./app-bk-2024-3-27.vue?vue&type=script&lang=ts"

import "./app-bk-2024-3-27.vue?vue&type=style&index=0&id=6484f094&lang=css"

import exportComponent from "/Users/user/Desktop/kafka/paletteiot/pletteiotweb/PaletteIoTDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__